import { isEmpty } from 'lodash';
import btoaMethod from 'btoa';

/**
 * Checks if a utfGrid for a layer in the specified URL can be fetched.
 *
 * @async
 * @param {string} url - The URL where the utfGrid is stored.
 * @param {string} [connectionParams={}] - The user-password pair for the connection.
 * @returns {Promise<boolean>} - True if the URL exists and False if it doesn't exist.
 * @throws {Error} If something goes wrong.
 */

const checkUTFGridInURL = async (url, connectionParams = {}) => {
  if (isEmpty(url)) return false;

  const headers = {};
  if (!isEmpty(connectionParams.user) && !isEmpty(connectionParams.password)) {
    const encodedTokenAuth = btoaMethod(`${connectionParams.user}:${connectionParams.password}`);
    headers['content-type'] = 'text/plain';
    headers.Authorization = `Basic ${encodedTokenAuth}`;
  }

  try {
    const response = await fetch(url);
    if (response.ok) {
      const contentAsText = await response.text();
      const content = JSON.parse(contentAsText);
      return content.keys.length !== 1;
    }
    throw new Error('Network response was not ok. Server Error');
  } catch (err) {
    throw new Error(err.message);
  }
};

export default checkUTFGridInURL;
